import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AcknowledgementPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Acknowledgement</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The first author is thankful to the University Grant Commission,
              Government of India for providing Dr. D S Kothari Postdoctoral
              Fellowship.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AcknowledgementPage;
